/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/

import moment from "moment";
import { IFotaAddSysAdmin, IFotaTenantAdmin } from "../../models/Form/IFotaForm";
import { IFotaTenantReleaseLatest } from "../../models/response/IFotaResponse";
import { getEffectiveDateTime } from "../../constants/common-constants";

export const initialValuesSysAdmin: IFotaAddSysAdmin = {
  Version: "",
  File: "",
  FileContent: "",
  FileType:0,
  EffectiveDateTimestamp:getEffectiveDateTime(),
  Description: "",
  FileName: "",
  IsCustomFileNameWithExtension: false,
  IsCustomFileNameWithoutExtension: false,
  WantToUpdateFile:"false",
};

export const initialValuesTenantAdmin: IFotaTenantAdmin = {
  Version: "",
  File: "",
  FileName: "",
  IsCustomFileNameWithExtension: false,
  IsCustomFileNameWithoutExtension: false,
  FileType: 0,
  HostVersionFileContent: "",
  Description: "",
  WantToUpdateFile:"false",
};

export const initialValuesTenantLatestReleaseAdmin: IFotaTenantReleaseLatest = {
  MzlFotaReleaseId: -1,
  HostVersionFileContent: "",
  Version: "",
  File: "",
};